import appConfig from 'appConfig';
import { getTreeLayerNew, getScreenList } from '@/api/index';
export default {
  name: 'treeContrast',
  data() {
    return {
      comparlayers: [],
      currentSelects: [],
      currentArr: [],
      loadtreeText: '数据加载中...',
      projection: [],
      selectList: [],
      selectValue: '',
      ids: '',
    };
  },
  components: {},
  computed: {},
  props: {
    mapdata: {
      type: Object,
      default: this.olmap,
    },
    rollerLeft: {
      type: Boolean,
      default: false,
    },
    isRoller: {
      type: Boolean,
      default: false,
    },
    selectName: {
      type: String,
      default: '',
    },
  },
  mounted() {},
  created() {
    this.loadtreeText = '数据加载中...';
    var treeData = this.publicMethod.treeData;
    var extent = [-180, -90, 180, 90];
    proj4.defs(appConfig.map.proj, '+proj=longlat +ellps=GRS80 +no_defs');
    //投影坐标系
    this.projection = new this.$olmap.proj.Projection({
      code: appConfig.map.proj,
      units: this.$olmap.proj.Units.METERS,
      extent: extent,
    });
    // if (treeData) {
    //   this.comparlayers = JSON.parse(JSON.stringify(treeData));
    // } else {
    let roles = JSON.parse(localStorage.getItem('userInfo')).roles;
    var getTreeIds = roles[0].layerData;
    if (getTreeIds) {
      this.ids = getTreeIds;
      this.getParentList();
    } else {
      this.loadtreeText = '暂无数据';
    }
    // }
  },
  methods: {
    /*
     *@description: 选择筛选框的事件
     *@author: qqjuanqq
     *@date: 2023-04-18 18:07:48
     *@version: V1.0.0
     */
    changeSlect(code) {
      this.selectValue = code.value;
      this.getList();
    },
    async getParentList(ids) {
      this.loadtreeText = '数据加载中...';
      var param = {
        type: '1',
      };
      let resList = await getScreenList(param);
      if (resList.code == 200 && resList.success) {
        this.selectList = resList.result;
        this.selectValue = this.selectList[0].id;
        this.getList();
      }
    },
    /*
     *@description: 获取目录树的接口
     *@author: qqjuanqq
     *@date: 2023-04-18 18:08:01
     *@version: V1.0.0
     */
    getList() {
      var that = this;
      var param = {
        id: this.selectValue,
        name: '',
        ids: this.ids,
      };
      getTreeLayerNew(param).then(res => {
        if (res.success) {
          const filterMenu = menuList => {
            return menuList
              .filter(item => {
                if (item.contextmenu) {
                  item.contextmenu = false;
                }
                return item.visible == true;
              })
              .map(item => {
                menuList.push(
                  Object.assign(item, { checked: item.title == that.selectName ? true : false })
                ); //浅拷贝 就没关系
                if (item.children) {
                  if (item.children.constructor != Array) {
                    //当子节点只有一个的时候
                    var aa = [];
                    aa.push(item.children);
                    item.children = aa;
                  }
                  item.children = filterMenu(item.children);
                }
                return item;
              });
          };
          this.comparlayers = filterMenu(res.result);
          this.publicMethod.treeData = this.comparlayers
            ? JSON.parse(JSON.stringify(this.comparlayers))
            : this.comparlayers;
          //获取勾选事件
          this.$nextTick(function() {
            //获取勾选事件
            if (this.$refs.componenttree) {
              var nodes = this.$refs.componenttree.getCheckedNodes();
              this.sel(nodes, nodes);
            }
          });
        } else {
          this.loadtreeText = '暂无数据';
        }
      });
    },
    /*
     *@description:缩放到地图  change
     *@author: qqjuanqq
     *@date: 2023-04-18 18:05:14
     *@version: V1.0.0
     */
    async handleSetZoom(itemCode) {
      if (itemCode.length == 1) {
        var extentList = [];
        var _this = this;
        let res = await this.publicMethod.getlayerXML(itemCode[0].url);
        if (res) {
          $(res)
            .find('Layer')
            .find('Layer')
            .each(function() {
              var item = $(this);
              if (item.find('Name').text() == itemCode[0].layername.split(':')[1]) {
                extentList.push(
                  Number(item.find('BoundingBox').attr('minx')),
                  Number(item.find('BoundingBox').attr('miny')),
                  Number(item.find('BoundingBox').attr('maxx')),
                  Number(item.find('BoundingBox').attr('maxy'))
                );
                _this.mapdata.getView().fit(extentList);
              }
            });
        }
      }
    },
    // 树渲染逻辑
    renderContent(h, { root, node, data }) {
      if (data.nodeType == '1') {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('Icon', {
                props: {
                  type: 'ios-folder',
                },
                style: {
                  marginRight: '8px',
                  color: '#0099fa',
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      } else if (data.icon == 'line') {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('div', {
                style: {
                  marginRight: '5px',
                  width: '17px',
                  height: '13px',
                  'background-repeat': 'no-repeat',
                  display: 'inline-block',
                  'background-image': "url('../../../../static/image/layericon/line.png')",
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      } else if (data.icon == 'polygon') {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('div', {
                style: {
                  marginRight: '5px',
                  width: '17px',
                  height: '13px',
                  'background-repeat': 'no-repeat',
                  display: 'inline-block',
                  'background-image': "url('../../../../static/image/layericon/fill.png')",
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      } else if (data.icon == 'polygon2') {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('div', {
                style: {
                  marginRight: '5px',
                  width: '17px',
                  height: '13px',
                  'background-repeat': 'no-repeat',
                  display: 'inline-block',
                  'background-image': "url('../../../../static/image/layericon/polygon2.png')",
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      } else if (data.suffix == 'png' || data.suffix == 'jpg' || data.suffix == 'gif') {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('div', {
                style: {
                  marginRight: '5px',
                  width: '17px',
                  height: '13px',
                  'background-repeat': 'no-repeat',
                  display: 'inline-block',
                  'background-image': "url('../../../../static/image/layericon/img.png')",
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      } else if (data.suffix == 'pdf') {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('div', {
                style: {
                  marginRight: '5px',
                  width: '17px',
                  height: '13px',
                  'background-repeat': 'no-repeat',
                  display: 'inline-block',
                  'background-image': "url('../../../../static/image/layericon/pdf.png')",
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      } else if (data.suffix == 'txt') {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('div', {
                style: {
                  marginRight: '5px',
                  width: '17px',
                  height: '13px',
                  'background-repeat': 'no-repeat',
                  display: 'inline-block',
                  'background-image': "url('../../../../static/image/layericon/txt.png')",
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      } else {
        return h(
          'span',
          {
            style: {
              display: 'inline-block',
              width: '100%',
            },
          },
          [
            h('span', [
              h('div', {
                style: {
                  marginRight: '5px',
                  width: '17px',
                  height: '13px',
                  'background-repeat': 'no-repeat',
                  display: 'inline-block',
                  'background-image': "url('../../../../static/image/layericon/point.png')",
                },
              }),
              h('span', data.title),
            ]),
          ]
        );
      }
    },
    addTreeArr(list) {
      for (var i = 0; i < list.length; i++) {
        var chlist = list[i];
        if (chlist.children && chlist.children.length > 0) {
          this.addTreeArr(chlist.children);
        } else {
          if (chlist.type != 'dir') {
            var items = this.currentArr.find(item => item.id == chlist.id);
            if (!items) {
              this.currentArr.push(chlist);
            }
          }
        }
      }
    },
    delTreeArr(sel) {
      for (var i = 0; i < sel.length; i++) {
        var chlist = sel[i];
        if (chlist.children && chlist.children.length > 0) {
          this.delTreeArr(chlist.children);
        } else {
          if (chlist.type != 'dir') {
            this.currentArr = this.getSubtract(this.currentArr, [chlist]);
          }
        }
      }
    },
    //数组求差
    getSubtract(unionArr, subsetArr) {
      var new_tmp = new Array();
      for (var i = 0; i < unionArr.length; i++) {
        //已选择的图层
        var flag = true;
        for (var j = 0; j < subsetArr.length; j++) {
          //选择被移除的图层
          if (unionArr[i].id == subsetArr[j].id) {
            flag = false;
          }
        }
        if (flag) {
          new_tmp.push(unionArr[i]);
        }
      }
      return new_tmp;
    },
    // 勾选事件和取消勾选的事件
    sel(a, sele) {
      console.log(a,sele);
      // 对选择的数据进行排序处理 针对b
      if (sele.checked) {
        //为true 表示选中的
        this.addTreeArr([sele]);
      } else {
        this.delTreeArr([sele]);
      }
      var tmp = a; //当前已勾选的全部节点
      var selects = [];
      for (var i = 0; i < tmp.length; i++) {
        if (tmp[i].children && tmp[i].children.length > 0) continue;
        selects.push(tmp[i]);
      }
      if (this.currentSelects.length - selects.length > 0) {
        //取消勾选
        for (var i = this.currentSelects.length - 1; i >= 0; i--) {
          for (var j = 0; j < selects.length; j++) {
            if (this.currentSelects[i].id == selects[j].id) {
              this.currentSelects.splice(i, 1);
              break;
            }
          }
        }
        var deleteLayers = this.currentSelects;
        this.currentSelects = selects;
        var arr = this.mapdata.getLayers().array_;
        for (var i = arr.length - 1; i >= 0; i--) {
          var layer = arr[i];
          var id = layer.get('id');
          for (var j = 0; j < deleteLayers.length; j++) {
            if ('_layertree_' + deleteLayers[j].id == id) {
              if (!this.rollerLeft) {
                this.$emit('removeRightLayer', layer);
              }
              this.mapdata.removeLayer(layer);
              break;
            }
          }
        }
      } else {
        //添加勾选
        var tmp = selects.concat();
        for (var i = selects.length - 1; i >= 0; i--) {
          for (var j = 0; j < this.currentSelects.length; j++) {
            if (this.currentSelects[j].id == selects[i].id) {
              selects.splice(i, 1);
              break;
            }
          }
        }
        var addLayers = selects;
        this.currentSelects = tmp;
        var zindex = 500;
        zindex++;
        for (var i = 0; i < addLayers.length; i++) {
          if (addLayers[i].url) {
            var layer = this.createLayer(addLayers[i], '_layertree_', zindex + i);
            if (this.rollerLeft) {
              this.$emit('rollerLeftLayer', layer);
            } else {
              this.$emit('rollerRightLayer', layer);
              // 叠加设置图层样式
              this.mapdata.addLayer(layer);
              if (addLayers[i].sldName) {
                let param = layer.getSource().getParams(); //先获取图层的样式
                param.STYLES = addLayers[i].sldName;
                layer.getSource().updateParams(param); //设置图层的样式
              }
            }
          }
        }
      }
    },
    // 创建图层的方法
    createLayer(config, prefix, zindex) {
      var objData = JSON.parse(JSON.stringify(config));
      objData.id = prefix + objData.id;
      var layer = null;
      if (objData.type == 'layer.VectorgeoServeRest' || objData.type == 'layer.ImageGeoServe') {
        layer = this.publicMethod.createGeoServerWMS(this.$olmap, objData, zindex);
      } else if (
        objData.type == 'layer.ImageGeoServerTilAndVec' ||
        objData.type == 'layer.VectorgeoServeCut' ||
        objData.type == 'layer.ImageGeoServeCut'
      ) {
        //切片的类型
        layer = this.publicMethod.getGeoServerWMTS(
          this.$olmap,
          this.projection,
          [
            appConfig.map.extent.XMin,
            appConfig.map.extent.YMin,
            appConfig.map.extent.XMax,
            appConfig.map.extent.YMax,
          ],
          objData,
          appConfig.map.origin,
          appConfig,
          zindex
        );
      } else if (objData.type == 'polygon' && objData.pname == '我的图层') {
        var layerStyle = new this.$olmap.style.Style({
          fill: new this.$olmap.style.Fill({
            color: 'rgba(255, 255, 255, 0.5)', //填充颜色
          }),
          stroke: new this.$olmap.style.Stroke({
            color: '#008000', //边框颜色
            width: 2, // 边框宽度
          }),
          image: new this.$olmap.style.Circle({
            radius: 1,
            fill: new this.$olmap.style.Fill({
              color: '#008000',
            }),
          }),
          text: new this.$olmap.style.Text({
            textBaseline: 'middle',
            rotateWithView: true,
            font: '10px Microsoft YaHei',
          }),
        });
        layer = this.publicMethod.createPolygonLayer(
          this.$olmap,
          config,
          zindex,
          prefix + config.id,
          layerStyle
        );
      } else if (objData.type == 'layer.ImageGeoServerVectorSlicing') {
        //矢量切片的数据
        layer = this.publicMethod.createGeoServerWMTSXYZ(
          this.$olmap,
          objData,
          appConfig.map,
          this.projection,
          zindex,
          styleData
        );
      }
      return layer;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/contrastComponent/treeContrast/treeContrast.js